"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputTypes = void 0;
const react_1 = __importStar(require("react"));
const styled = __importStar(require("./styled"));
const Utils_1 = require("../../../Utils");
const Typography_1 = __importStar(require("../Typography"));
const uniqueId_1 = __importDefault(require("lodash/uniqueId"));
const svg_components_1 = require("../../../assets/svg-components");
const useDebounce_1 = __importDefault(require(".././../../Hooks/useDebounce"));
const StepController_1 = __importDefault(require("./StepController/StepController"));
const styled_components_1 = require("styled-components");
const Hooks_1 = require("app/Hooks");
var InputTypes;
(function (InputTypes) {
    InputTypes["PASSWORD"] = "password";
    InputTypes["NUMBER"] = "number";
    InputTypes["TEXT"] = "text";
})(InputTypes = exports.InputTypes || (exports.InputTypes = {}));
const DELAY_TIME = 700;
const Input = (_a) => {
    var _b;
    var { value, setValue, min, max, integer, maxWidth, width, textarea, label, labelRight, maxLength, required, enableValidation, validationFunc, errorFromProps, placeholder, type, focus, disabled, centerInput, onPaste, numberControls, step, isSearchInput, onCrossClick, errorMessageFontSize } = _a, props = __rest(_a, ["value", "setValue", "min", "max", "integer", "maxWidth", "width", "textarea", "label", "labelRight", "maxLength", "required", "enableValidation", "validationFunc", "errorFromProps", "placeholder", "type", "focus", "disabled", "centerInput", "onPaste", "numberControls", "step", "isSearchInput", "onCrossClick", "errorMessageFontSize"]);
    const { t } = (0, Hooks_1.useTranslate)();
    const [inputId] = (0, react_1.useState)((0, uniqueId_1.default)('input-'));
    const [isFocused, setIsFocused] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)();
    const [togglePassword, setTogglePassword] = (0, react_1.useState)(() => type !== InputTypes.PASSWORD);
    const debouncedValue = (0, useDebounce_1.default)(value, DELAY_TIME);
    const theme = (0, styled_components_1.useTheme)();
    const onChange = (e) => {
        const value = e.currentTarget.value;
        if (disabled)
            return;
        if (enableValidation && validationFunc) {
            setError(validationFunc(value === null || value === void 0 ? void 0 : value.toString()));
        }
        if (type === InputTypes.NUMBER) {
            if (value === '' || (0, Utils_1.isNum)(value) || value === '-') {
                setValue(value);
            }
        }
        else {
            setValue(value);
        }
    };
    (0, react_1.useEffect)(() => {
        if (enableValidation && validationFunc) {
            setError(validationFunc(value === null || value === void 0 ? void 0 : value.toString()));
        }
    }, [enableValidation]);
    (0, react_1.useEffect)(() => {
        if (type === InputTypes.NUMBER) {
            const debouncedString = `${debouncedValue}`;
            if (integer && debouncedString.includes('.')) {
                setValue(Math.round(Number(debouncedValue)));
                return;
            }
            if (Number(debouncedValue) < min) {
                setValue(min);
                return;
            }
            if (Number(debouncedValue) > max) {
                setValue(max);
                return;
            }
            if (debouncedString[debouncedString.length - 1] === '.') {
                setValue(debouncedString.slice(0, -1));
                return;
            }
            if (debouncedString === '') {
                setValue(min);
                return;
            }
            if ((debouncedString === null || debouncedString === void 0 ? void 0 : debouncedString.length) > 1 && debouncedString[0] === '0' && debouncedString[1] !== '.') {
                setValue(Number(debouncedString));
                return;
            }
            if (debouncedString === '0.0') {
                setValue(0);
                return;
            }
            if (step && debouncedString !== '0') {
                const digitsAfterDecimalInStep = (0, Utils_1.digitsAfterDecimal)(step);
                setValue(Number(debouncedValue).toFixed(digitsAfterDecimalInStep));
            }
        }
    }, [debouncedValue]);
    const isErrorMessage = (errorFromProps === null || errorFromProps === void 0 ? void 0 : errorFromProps.message) || (error === null || error === void 0 ? void 0 : error.message);
    return (react_1.default.createElement(styled.Container, Object.assign({ maxWidthProps: maxWidth, widthProps: width }, props),
        label && (react_1.default.createElement(styled.LabelContainer, null,
            react_1.default.createElement(styled.Label, { htmlFor: inputId, required: required },
                react_1.default.createElement(Typography_1.default, { type: Typography_1.Types.LABEL_ON_FORM }, label)))),
        textarea ? (react_1.default.createElement(styled.Textarea, { id: inputId, value: value, onChange: (e) => onChange(e), maxLength: maxLength, placeholder: placeholder })) : (react_1.default.createElement(styled.InputContainer, { error: (enableValidation && !!(error === null || error === void 0 ? void 0 : error.error)) || (errorFromProps === null || errorFromProps === void 0 ? void 0 : errorFromProps.error), isFocused: isFocused },
            react_1.default.createElement(styled.Input, { id: inputId, value: value, onChange: (e) => onChange(e), onFocus: () => setIsFocused(true), onBlur: () => setIsFocused(false), error: enableValidation || (errorFromProps === null || errorFromProps === void 0 ? void 0 : errorFromProps.error), maxLength: maxLength, type: togglePassword ? InputTypes.TEXT : InputTypes.PASSWORD, placeholder: placeholder, autoFocus: focus, centerInput: centerInput, onPaste: e => onPaste === null || onPaste === void 0 ? void 0 : onPaste(e), disabled: disabled }),
            type === InputTypes.PASSWORD && (react_1.default.createElement(styled.PasswordButton, { type: "button", "aria-label": t(`/haldex/attributes/aria-label/${togglePassword ? 'hide' : 'show'}-password`), onClick: () => setTogglePassword(prevState => !prevState) }, !togglePassword ? react_1.default.createElement(svg_components_1.EyeOffIcon, null) : react_1.default.createElement(svg_components_1.EyeOnIcon, null))),
            isSearchInput ? (((_b = `${value}`) === null || _b === void 0 ? void 0 : _b.length) > 0 ? (react_1.default.createElement(styled.CrossButton, { "aria-label": t('/haldex/attributes/aria-label/close'), onClick: onCrossClick },
                react_1.default.createElement(svg_components_1.CrossIcon, null))) : (react_1.default.createElement(svg_components_1.SearchIcon, { stroke: theme.palette.LIGHT_BLACK }))) : null,
            numberControls ? (react_1.default.createElement(StepController_1.default, { setValue: setValue, step: step, error: errorFromProps || error, min: min, max: max })) : (error === null || error === void 0 ? void 0 : error.error) || (errorFromProps === null || errorFromProps === void 0 ? void 0 : errorFromProps.error) ? (react_1.default.createElement(svg_components_1.ValidationErrorIcon, null)) : null)),
        labelRight && react_1.default.createElement(styled.LabelRightContainer, null, labelRight),
        isErrorMessage && (react_1.default.createElement(styled.ErrorMessage, { type: Typography_1.Types.BODY_2, fontSize: errorMessageFontSize }, (errorFromProps === null || errorFromProps === void 0 ? void 0 : errorFromProps.message) ? errorFromProps.message : error.message))));
};
exports.default = Input;
